var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLineHightImgNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 15,
    viewBox: "0 0 20 14.837",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30911",
    "data-name": "Group 30911",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50128",
    "data-name": "Path 50128",
    d: "M431.77,134.7h-5.555a1.639,1.639,0,1,1,0-3.277h1.131v-8.283h-2.17v.9a1.648,1.648,0,0,1-3.3,0V121.5a1.645,1.645,0,0,1,1.647-1.639h10.929A1.645,1.645,0,0,1,436.1,121.5v2.536a1.648,1.648,0,0,1-3.3,0v-.9h-2.169v8.283h1.129a1.639,1.639,0,1,1,0,3.277Zm-5.555-2.477a.839.839,0,1,0,0,1.677h5.555a.839.839,0,1,0,0-1.677h-1.531a.4.4,0,0,1-.4-.4v-9.083a.4.4,0,0,1,.4-.4h2.973a.4.4,0,0,1,.4.4v1.3a.843.843,0,0,0,1.687,0V121.5a.842.842,0,0,0-.844-.839H423.528a.842.842,0,0,0-.843.839v2.536a.843.843,0,0,0,1.687,0v-1.3a.4.4,0,0,1,.4-.4h2.974a.4.4,0,0,1,.4.4v9.083a.4.4,0,0,1-.4.4Z",
    transform: "translate(-416.105 -119.864)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_30619",
    "data-name": "Group 30619"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50129",
    "data-name": "Path 50129",
    d: "M413.164,134.7a.4.4,0,0,1-.395-.4V120.264a.395.395,0,1,1,.79,0V134.3A.4.4,0,0,1,413.164,134.7Z",
    transform: "translate(-410.878 -119.864)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50130",
    "data-name": "Path 50130",
    d: "M412.543,122.561a.393.393,0,0,1-.279-.116l-1.629-1.629-1.628,1.629a.395.395,0,0,1-.558-.558l1.907-1.907a.4.4,0,0,1,.558,0l1.907,1.907a.395.395,0,0,1-.279.674Z",
    transform: "translate(-408.333 -119.864)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50131",
    "data-name": "Path 50131",
    d: "M410.635,150.581a.392.392,0,0,1-.279-.116l-1.907-1.907a.395.395,0,1,1,.558-.558l1.628,1.629L412.264,148a.395.395,0,1,1,.558.558l-1.907,1.907A.393.393,0,0,1,410.635,150.581Z",
    transform: "translate(-408.333 -135.744)",
    fill: "#333"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineHightImgNew);
export default __webpack_public_path__ + "static/media/lineHightImgNew.78fb7bc7.svg";
export { ForwardRef as ReactComponent };